import FetchWrapper from "@/components/UI/FetchWraper";
import AvatarWithInitials from "@/components/UI/AvatarWithInitials";
import StatusTransition from "@/components/UI/StatusTransition";
import FolderIcon from "@/assets/icons/folder_off.svg?react";
import { formatDateTimeWithAt } from "@/utils/dateUtils";

type Discrepancy = {
  actor: {
    id: string | null;
    name: string;
  };
  field: string;
  field_label: string;
  from_value: string;
  to_value: string;
  at: string;
  source: string | null;
  discrepancy_id: string;
  issue_id: string | null;
};

type DiscrepanciesHistoryData = {
  count: number;
  next: string | null;
  previous: string | null;
  results: Discrepancy[];
};

type DiscrepanciesHistoryProps = {
  discrepancyId: string;
  refetchTrigger?: number;
};

export default function DiscrepanciesHistory({
  discrepancyId,
  refetchTrigger,
}: DiscrepanciesHistoryProps) {
  return (
    <FetchWrapper
      endpointSuffix={`issue_management/history/actions/${discrepancyId}/`}
      extraQueryKey={refetchTrigger?.toString() || ""}
    >
      {(data: DiscrepanciesHistoryData) => (
        <DiscrepanciesHistoryContent data={data} />
      )}
    </FetchWrapper>
  );
}

type DiscrepanciesHistoryContentProps = {
  data: DiscrepanciesHistoryData;
};

const DiscrepanciesHistoryContent = ({
  data,
}: DiscrepanciesHistoryContentProps) => {
  if (data.results.length === 0) {
    return (
      <div className="flex flex-col items-center mt-8 h-20 text-[#00000073]">
        <FolderIcon />
        No user history
      </div>
    );
  }
  return (
    <div>
      {data.results.map((discrepancy, index) => (
        <div key={index} className="flex flex-col mt-7 mb-7">
          <div className="flex items-center gap-1">
            <AvatarWithInitials
              name={discrepancy.actor?.name || "Unassigned"}
              avatarSize={28}
              labelFontSize={14}
            />{" "}
            updated the
            <p>{discrepancy.field_label || "Unknown field"}</p>
            <div className="text-[#00000073]">
              {discrepancy.at
                ? formatDateTimeWithAt(discrepancy.at)
                : "Unknown Date"}
            </div>
          </div>
          <div className="flex gap-2 ml-10">
            <StatusTransition
              type={
                discrepancy.field as
                  | "discrepancy_assignee"
                  | "discrepancy_status"
                  | "discrepancy_resolution_status"
              }
              fromValue={discrepancy.from_value}
              toValue={discrepancy.to_value}
              avatarConfig={{ avatarSize: 28, labelFontSize: 14 }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
